import GroupSolidIcon from '@eduzz/houston-icons/GroupSolid';
import Button from '@eduzz/houston-ui/Button';
import { FormControlLabel } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import React, { useCallback, useState } from 'react';
import MyModal from 'v2/components/Shared/MyModal';

interface IProps {
  onAccept: () => void;
}

export const SelectIntroduction = ({ onAccept }: IProps) => {
  const [open, setOpen] = useState(false);

  const onConfirm = useCallback(() => {
    setOpen(false);
    if (onAccept) onAccept();
  }, [onAccept]);

  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Grid container spacing={2} justifyContent='center' alignItems='center' style={{ textAlign: 'center' }}>
        <Grid item xs={12}>
          <Typography variant='h6'>Você deseja trabalhar com afiliados?</Typography>
        </Grid>
        <Grid item xs={12} style={{ maxWidth: 600 }}>
          <Typography variant='body1'>
            O programa de afiliados e o marketing de afiliados é a melhor estratégia para capitalizar as vendas do seu produto sem realizar grandes
            investimentos. Comece a trabalhar com afiliados agora mesmo!
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Button variant='contained' color='primary' onClick={() => setOpen(true)} startIcon={<GroupSolidIcon />}>
            Habilitar vendas por afiliados
          </Button>
        </Grid>
      </Grid>
      <Confirm open={open} onClose={onClose} onConfirm={onConfirm} />
    </>
  );
};

const Confirm = ({ open, onClose, onConfirm }: { open: boolean; onClose: () => void; onConfirm: () => void }) => {
  const [accept, setAccept] = useState<boolean>(false);
  return (
    <MyModal
      title='Vendas por afiliados'
      opened={open}
      onClose={onClose}
      onSubmit={onConfirm}
      submitDisabled={!accept}
      buttonOk='Habilitar vendas por afiliados'
      buttonCancel='Agora não'
    >
      Ao habilitar e salvar o produto com a funcionalidade de vendas por afiliados, esteja ciente que ela não poderá ser desabilitada.
      <FormControlLabel
        control={<Checkbox color='secondary' checked={accept} onChange={() => setAccept((v) => !v)} />}
        label='Estou de acordo com a política de vendas por afiliados'
      />
    </MyModal>
  );
};
